<template>
  <Combobox
    :showClear="true"
    :groups="statuses"
    :name="name"
    :triggerLabel="name"
    :handle="handle"
    type="dot"
    @update:open="emit('update:open', $event)"
  />
</template>

<script setup>
// Libraries
import { ref } from "vue";
import { useStatuses } from ".";

// Components
import { Combobox } from "@/SharedComponents/Filters/Combobox";

// Emits
const emit = defineEmits(["update:open"]);

// Props
defineProps({
  name: {
    type: String,
    required: true,
  },
});

// Refs
const handle = ref("status");
const { statuses } = useStatuses();
</script>
